import { Radio, RadioChangeEvent } from "antd";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../app/store";
import { setFilterField, setGlobalFilter, resetAllFilters } from "../../app/store/reducers/appSlice";
import { FilterBlock, FilterGroup, IconWrapper, RadioContent, RadioText, RadioLabel } from "./styles"; // Добавляем RadioLabel

enum Fields {
    ProductionType = 'productionType',
}

export enum ProductionType {
    ALL = 'all',
    SHIP_TECH = 'shipTech',
    AQUAFARM = 'aquafarm',
}

export default function ProductionTypeFilter() {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { filter } = useAppSelector(store => store.AppSlice);

    const onChangeRadio = (e: RadioChangeEvent) => {
        console.log(`production type = ${e.target.value}`);
        dispatch(resetAllFilters());
        dispatch(setGlobalFilter(""));
        dispatch(setFilterField({
            name: Fields.ProductionType,
            value: e.target.value
        }));
    };

    const ShipIcon = () => (
        <IconWrapper style={{ backgroundImage: "url(https://seafoodexporussia.com/upload/ship.png)" }} />
    );

    const FarmIcon = () => (
        <IconWrapper style={{ backgroundImage: "url(https://seafoodexporussia.com/upload/farm.png)" }} />
    );

    const AllIcon = () => (
        <IconWrapper style={{ backgroundImage: "url(/icons/all.svg)" }} />
    );

    return (
        <div style={{ marginBottom: '16px' }}>
            <FilterGroup>
                <Radio.Group
                    onChange={onChangeRadio}
                    value={filter.productionType || ProductionType.ALL}
                >
                    <FilterBlock>
                        <RadioLabel>
                            <Radio value={ProductionType.ALL} />
                            <RadioContent>
                                {t("All")}
                            </RadioContent>
                        </RadioLabel>
                    </FilterBlock>
                    <FilterBlock>
                        <RadioLabel>
                            <Radio value={ProductionType.SHIP_TECH} />
                            <RadioContent>
                                <ShipIcon />
                                <RadioText>
                                    {t("ShipTech")}
                                </RadioText>
                            </RadioContent>
                        </RadioLabel>
                    </FilterBlock>
                    <FilterBlock>
                        <RadioLabel>
                            <Radio value={ProductionType.AQUAFARM} />
                            <RadioContent>
                                <FarmIcon />
                                <RadioText>
                                    {t("Aquafarm")}
                                </RadioText>
                            </RadioContent>
                        </RadioLabel>
                    </FilterBlock>
                </Radio.Group>
            </FilterGroup>
        </div>
    );
}